export function sidebarToggle(collapsedMenuClicked: boolean): void {
    if (collapsedMenuClicked) {
        expandCollapsedSidebar();
    }
    else {
        toggleSidebarForButtonClick();
    }

    setCollapsedNavState();
}

function expandCollapsedSidebar() {
    removeCollapsedStyle();
    if (isSmallMediaRules()) {
        document.querySelector('.page-wrapper').classList.add('admin-sidebar--opened');
    }
}

function toggleSidebarForButtonClick() {
    if (isSmallMediaRules()) {
        removeCollapsedStyle();
        document.querySelector('.page-wrapper').classList.toggle('admin-sidebar--opened');
    } else {
        document.querySelector('.page-wrapper').classList.toggle('admin-sidebar--collapsed');
    }
}

export function toggleParentMenu(this: HTMLElement, _e: Event): void {
    const parent = (this.parentNode as HTMLElement);

    const isClosing = parent.classList.contains('admin-sidebar_menu_item--open') && !isNavCollapsed();

    closeAllParentMenus();

    if (!isClosing) {
        if (isNavCollapsed()) {
            sidebarToggle(true);
        }
        parent.classList.add('admin-sidebar_menu_item--open');
        this.scrollIntoView({ behavior: "smooth" });
    }
}

const closeAllParentMenus = () =>
    document.querySelectorAll('li.admin-sidebar_menu_item--parent')
        .forEach(parent => parent.classList.remove('admin-sidebar_menu_item--open'));


function setCollapsedNavState() {
    setCookie('isNavCollapsed', isNavCollapsed().toString(), 2);
}

function setCookie(name: string, value: string, days: number) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; secure";
}

const isNavCollapsed = () => !isNavExpanded();

const isNavExpanded = () =>
    isSmallMediaRules()
        ? hasOpenedStyle()
        : !hasCollapsedStyle();

const isSmallMediaRules = () => window.matchMedia('screen and (max-width: 767px)').matches;

const hasOpenedStyle = () => document.querySelector('.page-wrapper').classList.contains('admin-sidebar--opened');

const hasCollapsedStyle = () => document.querySelector('.page-wrapper').classList.contains('admin-sidebar--collapsed');

const removeCollapsedStyle = () => document.querySelector('.page-wrapper').classList.remove('admin-sidebar--collapsed');
